import { render } from "./UserSettingsPage.vue?vue&type=template&id=84eea396&scoped=true"
import script from "./UserSettingsPage.vue?vue&type=script&lang=js"
export * from "./UserSettingsPage.vue?vue&type=script&lang=js"

import "./UserSettingsPage.vue?vue&type=style&index=0&id=84eea396&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84eea396"]])

export default __exports__